export default __webpack_public_path__ + "static/media/incorrect-icon.5405a07a.svg";